import { withInstall } from '@tw-element/utils'
import Result from './src/result.vue'

export const TwResult = withInstall(Result)

export default TwResult

export * from './src/result'
